import {
    Dialog,
    Divider,
    DialogContent,
    Grid,
} from "@mui/material"
import BaseDialogTitle from "src/components/dialog/BaseDialogTitle"
import React, {Fragment, useEffect, useState} from "react";
import {LoaderBlockUI} from "../../../../../components/loader";
import DialogNewAfiliationForm from "./DialogNewAfiliationForm";
import {HttpClient} from "../../../../../http/client/httpClient";
import {
    Client,
    ClientRelationshipView,
    ClientRelationshipViewFields
} from "../../../../../types/client/clientData";
import CompanyCuitSyncDialogContent
    from "../../../../../@core/layouts/components/horizontal/app-bar-content/CompanyCuitSyncDialogContent";

interface DialogNewAfiliationProps {
    open: boolean,
    onNewAffiliated: () => void,
    clientId: number,
    clientToEdit?: ClientRelationshipView,
    onClose: () => void,
    clientRelationships: ClientRelationshipView[],
    solicitationId?: number,
    onReload?: () => void,
    clientClassificationCode: number | null
}

const DialogNewAfiliation = (props: DialogNewAfiliationProps) => {
    const [cuitValidate, setCuitValidate] = useState<boolean>(false)
    const [client, setClient] = useState<Client>()
    const [loading, setLoading] = useState<boolean>(false)
    
    
    useEffect(() => {
        if(props.clientToEdit && !client) {
            setLoading(true)
            HttpClient.getById(props.clientToEdit[ClientRelationshipViewFields.ClientId]).then((r) => {
                setClient(r)
                setCuitValidate(true)
                setLoading(false)
            })
        }
    }, [props.clientToEdit])

    useEffect(() => {
        if (props.open) {
            setCuitValidate(false)
        }
    }, [props.open]);
    
    return (
        loading ? <LoaderBlockUI/>
            :
                            <Dialog open={props.open} onClose={() => {
                                props.onClose()
                                setCuitValidate(false)
                                setClient(undefined)
                            }} maxWidth={'md'} fullWidth>
                                <BaseDialogTitle title={props.clientToEdit ? 'Editar composición afiliatoria' : 'Nueva composición afiliatoria'}
                                                 onClose={() => {
                                                     props.onClose()
                                                     setCuitValidate(false)
                                                     setClient(undefined)
                                                 }}
                                />
                                <Divider />
                                <DialogContent>
                                    {
                                        (!cuitValidate) ?
                                            <Fragment>
                                                {
                                                    !props.clientToEdit && !client &&
                                                    <CompanyCuitSyncDialogContent subtitle={'Ingrese un CUIT para sincronizar los datos con AFIP y agilizar la operación'}
                                                                                  onSave={(client: Client) => {
                                                                                      setCuitValidate(true)
                                                                                      setClient(client)
                                                                                  }}
                                                    />
                                                }
                                            </Fragment>
                                            :
                                            <Grid container justifyContent={'center'} spacing={4}>
                                                {
                                                    client &&
                                                    <DialogNewAfiliationForm client={client}
                                                                             onNewAffiliated={() => {
                                                                                 setClient(undefined)
                                                                                 props.onNewAffiliated()
                                                                             }}
                                                                             parentClientId={props.clientId}
                                                                             onBack={() => {
                                                                                 setCuitValidate(false)
                                                                                 setClient(undefined)
                                                                                 props.clientToEdit && props.onClose()
                                                                             }}
                                                                             solicitationId={props.solicitationId}
                                                                             clientRelationshipLst={props.clientRelationships}
                                                                             clientClassificationCode={props.clientClassificationCode}
                                                                             onReload={props.onReload}
                                                    />
                                                }
                                            </Grid>
                                    }
                                </DialogContent>
                            </Dialog>
    )
}

export default DialogNewAfiliation